import { MessageCircle } from "lucide-react";
import { openWhatsApp } from "../../lib/whatsapp";

export const FloatingWhatsApp = () => {
    return (
        <button
            onClick={() => openWhatsApp("Hello RVS Electronics, I have an inquiry.")}
            aria-label="Chat on WhatsApp"
            data-testid="floating-whatsapp-btn"
            className="fixed bottom-24 right-6 md:bottom-28 md:right-8 z-[60] w-14 h-14 md:w-16 md:h-16 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-2xl hover:scale-110 transition-transform"
            style={{ boxShadow: "0 10px 30px rgba(37, 211, 102, 0.45)" }}
        >
            <MessageCircle className="w-7 h-7 md:w-8 md:h-8" strokeWidth={2.2} />
            <span className="absolute -top-1 -right-1 flex h-3 w-3">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75"></span>
                <span className="relative inline-flex rounded-full h-3 w-3 bg-white"></span>
            </span>
        </button>
    );
};
